import apiClient from './config';
import { Pago, PagoGrouped, CreateMultiplePagos } from "../../types/pagos";

// Obtener todos los pagos
export const fetchPagos = async (): Promise<Pago[]> => {
    const response = await apiClient.get('/payments');
    return response.data;
};

// Obtener pagos por suscripción
export const fetchPagosBySuscripcion = async (suscripcion_id: string): Promise<Pago[]> => {
    const response = await apiClient.get(`/payments/${suscripcion_id}`);
    return response.data;
};

// Obtener pagos agrupados por mes y año
export const fetchPagosGroupedByMonthAndYear = async (): Promise<PagoGrouped[]> => {
    const response = await apiClient.get('/payments/grouped-by-month-year');
    return response.data;
};

// Crear un nuevo pago
export const createPago = async (pago: Omit<Pago, '_id'>): Promise<Pago> => {
    const response = await apiClient.post('/payments', pago);
    return response.data.payment;
};

// Crear múltiples pagos
export const createMultiplePagos = async (data: CreateMultiplePagos): Promise<Pago[]> => {
    const response = await apiClient.post('/payments/multiple', data);
    return response.data.payments;
};

// Actualizar un pago
export const updatePago = async (pago: Pago): Promise<Pago> => {
    const response = await apiClient.put(`/payments/${pago._id}`, pago);
    return response.data.payment;
};

// Eliminar un pago
export const deletePago = async (pagoId: string): Promise<void> => {
    await apiClient.delete(`/payments/${pagoId}`);
};